const apis = require('./apis')
import {request, rjhySms, rjhyUser, getToken, getHqInfo} from './request'
const transformRequest = [(data) => {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  return ret
}]

let headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
let headersJson = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

const getKlineByHttp = async (params) => {
  const token = await getToken()
  console.log('获取token===',token)
  return await getHqInfo(params,token)
}

const getEtfHistory = async (params) => {
  return await request._get(apis.quote.getEtfHistory, params, true)
}

const getStockGene = async ({market, code}) => {
  return await request._get(apis.quote.gene, {market, symbol: code})
}

const getStockDetail = async ({market, code}) => {
  return await request._get(apis.quote.stockDetail, {market, symbol: code})
}

const getFdStockDetail = async ({market, code}) => {
  return await request._get(apis.quote.getFdStockDetail, {market, symbol: code})
}

const getBillData = async ({market, code}) => {
  return await request._get(apis.quote.getBillList, {num: '10000', symbol: `${market}${code}`})
}

const getStockProfile = async Ei => {
  return await request.post({url: request.apis.quote.getAShareProfile, params: {Ei}})
}

const setFreesend = async (params) => {
  headers = request.createSign(params)
  const res = await rjhySms.post(request.apis.sms.captcha, params, { headers, transformRequest })
  return res
}

const login = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.user.login, params, { headers, transformRequest })
  return res
}
const publishDetail = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.stockBar.publishDetail, params, { headers, transformRequest })
  return res
}
const supportReview = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.stockBar.supportReview, params, { headers, transformRequest })
  return res
}
const unSupportReview = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.stockBar.unSupportReview, params, { headers, transformRequest })
  return res
}
const support = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.stockBar.support, params, { headers, transformRequest })
  return res
}
const unSupport = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.stockBar.unSupport, params, { headers, transformRequest })
  return res
}

//板块分时数据
const getPlateTrendData = async (params) => {
  return await request._get(apis.plateChart.tred, params, true)
}

//板块5日数据
const getPlateFiveTrendData = async (params) => {
  return await request._get(apis.plateChart.fiveTrend, params, true)
}

//板块5日数据
const getPlateHistoryTrendData = async (params) => {
  return await request._get(apis.plateChart.historyList, params, true)
}

export {
  getKlineByHttp,
  getStockGene,
  getStockDetail,
  getFdStockDetail,
  getBillData,
  getStockProfile,
  setFreesend,
  login,
  publishDetail,
  support,
  unSupport,
  supportReview,
  unSupportReview,
  getPlateTrendData,
  getPlateFiveTrendData,
  getPlateHistoryTrendData,
  getEtfHistory
}
